import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Engagements';

export const engagementEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  // Closure / Reopen
  closurePreview: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/closure-preview`, { id }),
  close: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/close`, { id }),
  reopen: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/reopen`, { id }),
  closureHistory: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/closure-history`, { id }),
  basePath: () => BASE_PATH,
} as const;

export default engagementEndpoints;
